export const actions = {
  set_state: 'distros/set_state',
  delete_distros: 'distros/delete_distros',
  get_distros: 'distros/get_distros',
  create_distros: 'distros/create_distros',
  update_distros: 'distros/update_distros',
  search_distros: 'distros/search_distros'
}
